<template>
  <div>
    <Form
      ref="searchForm"
      label-position="right"
      :label-width="90"
      class="search-list-430"
    >
      <Row class="relative" type="flex" flex="end">
        <FormItem label="课程类别">
          <Cascader
            v-model="typeList"
            style="width: 300px"
            change-on-select
            :disabled="
              (!schoolId && portOrg != 2) ||
                schoolId == -1||!!sheetId
            "
            :placeholder="
              (!schoolId && portOrg != 2) ||
                schoolId == -1
                ? '请选择学校'
                : '请选择'
            "
            :data="classTypeCascaderList"
            :load-data="loadTypeData"
          ></Cascader>
        </FormItem>
        <FormItem label="课程类型">
          <Select
            v-model="searchConds.offerOrgType"
            placeholder="请选择课程类型"
            clearable
            style="width: 300px"
            :disabled="!!sheetId"
          >
            <Option value="1">校内课程</Option>
            <Option value="2">校外课程</Option>
          </Select>
        </FormItem>
      </Row>
    </Form>
    <div class="search-other">
      <CheckboxGroup v-model="selectType">
        <Checkbox label="refund" :disabled="!!sheetId">
          <span>待退款课程(含已入班、未入班、材料费)</span>
        </Checkbox>
        <div class="time-box"><span class="time-text">退款单创建时间：</span><DatePicker :disabled="!!sheetId" :value="refundTimes" type="daterange" placement="bottom-end" placeholder="请选择退款单创建时间区间" style="width: 350px" @on-change="onDateChange($event,'refund')"></DatePicker></div>
        <Checkbox label="leave" :disabled="!!sheetId">
          <span>待退款请假可退款</span>
        </Checkbox>
        <div class="time-box"><span class="time-text">请假节次上课时间：</span><DatePicker :disabled="!!sheetId" :value="leaveTimes" type="daterange" placement="bottom-end" placeholder="请选择请假节次上课时间区间" style="width: 350px" @on-change="onDateChange($event,'leave')"></DatePicker></div>
      </CheckboxGroup>
    </div>
    <div class="btn-block">
      <Button type="primary" class="search-btn" shape="circle" @click="handleSearch">确认汇总待退款申请明细</Button>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import courseCenterApi from '@/request/courseCenter/courseCenterApi.js';
import { courseTypeData } from '../../assets/data/BatchRefund';
import { quelityTypeList, hostingTypeList } from '@/utils/dictionary';
export default {
  props: {
    schoolId: {
      type: String || Number,
      default: ''
    },
    sheetId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      selectType: [],
      datePickInfo: {
        refundApplyTimeBegin: '',
        refundApplyTimeEnd: '',
        leaveTimeBegin: '',
        leaveTimeEnd: ''
      },
      courseTypeData: courseTypeData,
      portOrg: Number(localStorage.getItem('portOrg')),
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      loadingSchool: false,
      searchConds: {
        offerOrgType: null

      },
      schoolIdList: [], // 学校
      termIdList: [], // 学期
      loading: false,
      typeList: [],
      quelityTypeList: [...quelityTypeList].slice(1, quelityTypeList.length), // 课程类型-素质
      hostingTypeList: [...hostingTypeList].slice(1, hostingTypeList.length), // 课程类型-基础托管
      courseTypeListAnother: [], // 课程分类
      classTypeCascaderList: [
        {
          value: '1',
          label: '素质课程'
        },
        {
          value: '2',
          label: '托管',
          children: [],
          loading: false
        }
      ],
      refundTimes: [],
      leaveTimes: []
    };
  },
  computed: {
    ...mapGetters(['theUserIdentity'])
  },
  methods: {
    async loadTypeData(item, callback) {
      if (this.sheetId) {
        callback();
      } else if (item.label === '素质课程' && item.value === 1) {
        this.searchConds.classType = item.value;
        callback();
      } else if (item.label === '托管') {
        item.loading = true;
        await this.getTapList(item.value);
        item.loading = false;
        if (this.loading) {
          delete item.loading;
        }
        callback();
      } else {
        // item.loading = true;
        // // this.courseTypeKind = item.value;
        // // 获取三级
        // await this.getCourseType(item.value);
        // item.children = this.courseTypeListAnother;
        // item.loading = false;
        callback();
      }
    },
    // 课程分类二级列表
    async getTapList(type) {
      const params = {
        orgId: this.schoolId,
        courseTypeAttr: type
      };
      const res = await courseCenterApi.getTapList(params);
      // console.log('res', res);
      if (res.status === 200) {
        if (res.message.length) {
          if (+type === 1) {
            const quelityTypeList = [];
            this.quelityTypeList.forEach((ele) => {
              res.message.forEach((item) => {
                if (ele.value == item) {
                  quelityTypeList.push(ele);
                }
              });
            });
            quelityTypeList.forEach((ele) => {
              ele.children = [];
              // ele.loading = false;
            });
            this.classTypeCascaderList.length > 0
              ? (this.classTypeCascaderList[0].children = quelityTypeList)
              : '';
          } else {
            const hostingTypeList = [];
            this.hostingTypeList.forEach((ele) => {
              res.message.forEach((item) => {
                if (ele.value == item) {
                  hostingTypeList.push(ele);
                }
              });
            });
            hostingTypeList.forEach((ele) => {
              ele.children = [];
              // ele.loading = false;
            });
            this.classTypeCascaderList[1].children = hostingTypeList;
          }
        } else {
          this.loading = true;
        }
      }
    },
    // 课程分类三级列表
    async getCourseType(courseTypeKind) {
      let params = {};
      switch (this.theUserIdentity) {
        // 当是机构端的时候 - orgId 传学校ID或者教育局ID
        case 'org':
          params = {
            orgId: this.schoolId,
            courseTypeKind
          };
          break;
        default:
          params = {
            orgId: this.schoolId,
            courseTypeKind
          };
          break;
      }
      const res = await courseCenterApi.getCourseTypeTapList(params);
      if (res.status === 200) {
        if (res.message.length) {
          res.message.forEach((ele) => {
            ele.value = ele.courseTypeId;
            ele.label = ele.courseTypeName;
          });
          this.courseTypeListAnother = res.message;
        } else {
          this.courseTypeListAnother = [];
        }
      }
    },
    onDateChange(date, type) {
      const begin = {
        refund: 'refundApplyTimeBegin',
        leave: 'leaveTimeBegin'
      };
      const end = {
        refund: 'refundApplyTimeEnd',
        leave: 'leaveTimeEnd'
      };
      if (date.length === 2 && date[0] !== '' && date[1] !== '') {
        this.datePickInfo[begin[type]] = `${date[0]} 00:00:00`;
        this.datePickInfo[end[type]] = `${date[1]} 23:59:59`;
      } else {
        this.datePickInfo[begin[type]] = '';
        this.datePickInfo[end[type]] = '';
      }
    },
    handleSearch() {
      let params = {};
      Object.keys(this.searchConds).forEach(item => {
        if (this.searchConds[item]) {
          params[item] = this.searchConds[item];
        }
      });
      if (this.selectType.includes('refund')) {
        const { refundApplyTimeBegin, refundApplyTimeEnd } = this.datePickInfo;
        params = { ...params, refundApplyTimeBegin, refundApplyTimeEnd };
      }
      if (this.selectType.includes('leave')) {
        const { leaveTimeBegin, leaveTimeEnd } = this.datePickInfo;
        params = { ...params, leaveTimeBegin, leaveTimeEnd };
      }
      this.$emit('on-search', params, this.typeList);
    },
    setSearchConds(data) {
      data.courseOrgType ? this.searchConds.offerOrgType = data.courseOrgType + '' : '';
      const { refundApplyTimeBegin, refundApplyTimeEnd, leaveTimeBegin, leaveTimeEnd } = data;
      if (data.refundApplyTimeBegin) {
        this.selectType.push('refund');
        this.refundTimes = [this.formatDate(data.refundApplyTimeBegin), this.formatDate(data.refundApplyTimeEnd)];
      }
      if (data.leaveTimeBegin) {
        this.selectType.push('leave');
        this.leaveTimes = [this.formatDate(data.leaveTimeBegin), this.formatDate(data.leaveTimeEnd)];
      }
      this.datePickInfo = { refundApplyTimeBegin, refundApplyTimeEnd, leaveTimeBegin, leaveTimeEnd };
      const list = [];
      if (data.classTypes) {
        list.push(data.classTypes);
        if (data.courseTypeKinds) {
          this.getTapList(data.classTypes);
          list.push(data.courseTypeKinds);
        }
      }
      console.log(list, '回显的000');
      this.typeList = list;
      this.handleSearch();
    },
    formatDate(time) {
      const newTime = /\d{4}-\d{2}-\d{2}/g.exec(time);
      return newTime[0];
    }

  }
};
</script>

<style lang="scss" scoped>
.search-other{
  border: 1px solid #999;
  border-radius: 10px;
  padding: 20px;
  margin:0 30px;
  label{
    display: block;
    margin-left: 20px;
  }
  label+label{
    margin-top: 20px;
  }
  .time-box{

    padding: 10px 0;
    .time-text{
      display: inline-block;
      width: 150px;
      text-align: right;
    }
  }
}
.btn-block{
  display: flex;
  justify-content: center;
  padding-top: 20px;
}

</style>
